import { FieldEditModalForm } from "./FieldEditModalForm"


const FieldEditModalFormWrapper = () => {
    return (<FieldEditModalForm />)
}

export {FieldEditModalFormWrapper}